import React, { FC } from 'react';
import { ApprovalModalFundedByProps } from './ApprovalModalFundedByProps';
import { Stack } from '@mui/material';
import SkappaCompleteSelect from '../SkappaCompleteSelect';
import useTranslation from '../../hooks/useTranslation';
import Text from '@ingka/text';

const ApprovalModalFundedBy: FC<ApprovalModalFundedByProps> = ({
  fundedBy,
  setFundedBy,
}) => {
  const t = useTranslation();
  return (
    <Stack>
      <Text style={{ fontWeight: '700' }}>{t('common.fundedBy')}</Text>
      <Text>
        <span>{t('ppm.fundedBy.description')}</span>
      </Text>
      <Stack mt={2}>
        <SkappaCompleteSelect
          value={fundedBy}
          label={t('common.fundedBy')}
          id={`funded-by-select`}
          onChange={setFundedBy}
          options={
            t('ppm.fundedBy.options') as unknown as { [key: string]: string }
          }
        />
      </Stack>
    </Stack>
  );
};

export default ApprovalModalFundedBy;
